<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="名称:" label-width="100px" prop="name">
					<el-input v-model="filters.name" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 220px)" border highlight-current-row v-loading="listLoading"
			@selection-change="selectGridChange" style="width: 100%;">
			<el-table-column prop="name" label="名称" width="150"></el-table-column>
			<el-table-column prop="addTime" label="添加时间" width="150" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column label="操作" width="250">
				<template scope="scope">
					<el-button  size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>

		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="closeDialog"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './sensitivewordsinfoadd.vue'
export default {
	components: { addsave,pagination },
	data() {
		return {
			filters: {
				name: '',
				rows: 20,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0
		}
	},
	methods: {
		handleSizeChange(val) {
			this.filters.rows = val;
			this.getGridData();
		},
		handleCurrentChange(val) {
			this.filters.page = val;
			this.getGridData();
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/basic/getsensitivewordsinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/basic/sensitivewordsinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增敏感词库";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
		closeDialog: function (bool) {
			this.dialogAddShow = bool
		},
		selectGridChange: function (sels) {
			this.sels = sels;
		}
	},
	async created() {
		this.getGridData();
	}
}

</script>

<style scoped></style>
